import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { getMockedCertmetricsCertificatesEdges } from '../mock-helpers';

export const mockFullLoggedOutUser: MockResponseConfig = {
  UnifiedSystemMutation: (variables: Variables) => ({
    data: {
      unified: {
        createUnifiedSystem: {
          errors: [],
          success: true,
          unifiedProfile: {
            bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
            company: 'Nike',
            aaid: '62587f99fdb60b0069294184',
            id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
            linkedinUrl: 'linkedin.com/colbystauss',
            location: 'Utah, USA',
            accountInternalId: '541b9286-8563-4825-aae8-43e7e90fb493',
            products: null,
            role: 'CEO',
            internalId: 'c34de571-576f-45e6-8c02-0917609af889',
            username: 'fullloggedout',
            websiteUrl: 'colbystauss.net',
            xUrl: null,
            youtubeUrl: null,
            isPrivate: false,
            isPersonalView: false,
            isLinkedView: false,
          },
        },
      },
    },
  }),
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="https://www.atlassian.com">Atlassian</a>.</p>',
          company: 'Nike',
          aaid: '62587f99fdb60b0069294184',
          linkedinUrl: 'linkedin.com/colbystauss',
          accountInternalId: '541b9286-8563-4825-aae8-43e7e90fb493',
          location: 'Kansas, USA',
          products: 'analytics,halp,hipchat',
          role: 'CEO',
          internalId: 'c34de571-576f-45e6-8c02-0917609af889',
          username: 'fullloggedout',
          websiteUrl: 'https://www.atlassian.com',
          xUrl: 'x.com/colby',
          youtubeUrl: 'youtube.com/colby',
          isPrivate: false,
          isPersonalView: false,
          isLinkedView: false,
        },
        atlassianProducts: {
          __typename: 'UnifiedAtlassianProductConnection',
          edges: [
            {
              cursor: '0',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/analytics',
                productId: 'analytics',
                title: 'Analytics Visualization Platform',
                type: 'category',
                viewHref: '/t5/Analytics-Visualization-Platform/ct-p/analytics',
              },
            },
            {
              cursor: '1',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/atlas',
                productId: 'atlas',
                title: 'Atlas',
                type: 'category',
                viewHref: '/t5/Atlas/ct-p/atlas',
              },
            },
            {
              cursor: '2',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/identity-manager',
                productId: 'identity-manager',
                title: 'Atlassian Access',
                type: 'category',
                viewHref: '/t5/Atlassian-Access/ct-p/identity-manager',
              },
            },
            {
              cursor: '3',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/bamboo',
                productId: 'bamboo',
                title: 'Bamboo',
                type: 'category',
                viewHref: '/t5/Bamboo/ct-p/bamboo',
              },
            },
            {
              cursor: '4',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/bitbucket',
                productId: 'bitbucket',
                title: 'Bitbucket',
                type: 'category',
                viewHref: '/t5/Bitbucket/ct-p/bitbucket',
              },
            },
            {
              cursor: '5',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/clover',
                productId: 'clover',
                title: 'Clover',
                type: 'category',
                viewHref: '/t5/Clover/ct-p/clover',
              },
            },
            {
              cursor: '6',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/announcements',
                productId: 'announcements',
                title: 'Community Announcements',
                type: 'category',
                viewHref: '/t5/Community-Announcements/ct-p/announcements',
              },
            },
            {
              cursor: '7',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/confluence',
                productId: 'confluence',
                title: 'Confluence',
                type: 'category',
                viewHref: '/t5/Confluence/ct-p/confluence',
              },
            },
            {
              cursor: '8',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/confluence-collection',
                productId: 'confluence-collection',
                title: 'Confluence Collection',
                type: 'category',
                viewHref:
                  '/t5/Confluence-Collection/ct-p/confluence-collection',
              },
            },
            {
              cursor: '9',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/crowd',
                productId: 'crowd',
                title: 'Crowd',
                type: 'category',
                viewHref: '/t5/Crowd/ct-p/crowd',
              },
            },
            {
              cursor: '10',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/data-center',
                productId: 'data-center',
                title: 'Data Center',
                type: 'category',
                viewHref: '/t5/Data-Center/ct-p/data-center',
              },
            },
            {
              cursor: '11',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/fisheye-crucible',
                productId: 'fisheye-crucible',
                title: 'FishEye/Crucible',
                type: 'category',
                viewHref: '/t5/FishEye-Crucible/ct-p/fisheye-crucible',
              },
            },
            {
              cursor: '12',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/halp',
                productId: 'halp',
                title: 'Halp',
                type: 'category',
                viewHref: '/t5/Halp/ct-p/halp',
              },
            },
            {
              cursor: '13',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/hipchat',
                productId: 'hipchat',
                title: 'HipChat',
                type: 'category',
                viewHref: '/t5/HipChat/ct-p/hipchat',
              },
            },
            {
              cursor: '14',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/jira',
                productId: 'jira',
                title: 'Jira',
                type: 'category',
                viewHref: '/t5/Jira/ct-p/jira',
              },
            },
            {
              cursor: '15',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/MarketplaceApps',
                productId: 'MarketplaceApps',
                title: 'Marketplace Apps',
                type: 'category',
                viewHref: '/t5/Marketplace-Apps/ct-p/MarketplaceApps',
              },
            },
            {
              cursor: '16',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/my-new-collection',
                productId: 'my-new-collection',
                title: 'My New Collection',
                type: 'category',
                viewHref: '/t5/My-New-Collection/ct-p/my-new-collection',
              },
            },
            {
              cursor: '17',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/atlassian-marketplace',
                productId: 'atlassian-marketplace',
                title: 'Product Add-ons',
                type: 'category',
                viewHref: '/t5/Product-Add-ons/ct-p/atlassian-marketplace',
              },
            },
            {
              cursor: '18',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/products-qa-category',
                productId: 'products-qa-category',
                title: 'Products QA Category',
                type: 'category',
                viewHref: '/t5/Products-QA-Category/ct-p/products-qa-category',
              },
            },
            {
              cursor: '19',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/sourcetree',
                productId: 'sourcetree',
                title: 'SourceTree',
                type: 'category',
                viewHref: '/t5/SourceTree/ct-p/sourcetree',
              },
            },
            {
              cursor: '20',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/statuspage',
                productId: 'statuspage',
                title: 'StatusPage',
                type: 'category',
                viewHref: '/t5/StatusPage/ct-p/statuspage',
              },
            },
            {
              cursor: '21',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/stride',
                productId: 'stride',
                title: 'Stride',
                type: 'category',
                viewHref: '/t5/Stride/ct-p/stride',
              },
            },
            {
              cursor: '22',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/trello',
                productId: 'trello',
                title: 'Trello',
                type: 'category',
                viewHref: '/t5/Trello/ct-p/trello',
              },
            },
            {
              cursor: '23',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/xyz',
                productId: 'xyz',
                title: 'XYZ',
                type: 'category',
                viewHref: '/t5/XYZ/ct-p/xyz',
              },
            },
          ],
          totalCount: 24,
        },
      },
    },
  }),
  AtlassianAccountUserQuery: (variables: Variables) => ({
    data: {
      me: {},
    },
  }),
  AtlassianAccountAnyUserQuery: (variables: Variables) => ({
    data: {
      user: {
        __typename: 'AtlassianAccountUser',
        nickname: 'Logged Out',
        picture:
          'https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128',
        id: 'ari:cloud:identity::user/62587f99fdb60b0069294184',
      },
    },
  }),
  KudosSummaryQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          gamification: {
            __typename: 'UnifiedGamification',
            id: 'ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184',
            recognitionsSummary: {
              __typename: 'UnifiedGamificationRecognitionsSummary',
              id: 'ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary',
              totals: [
                {
                  comment: 'for writing great content',
                  count: 1,
                },
                {
                  comment: 'just because',
                  count: 0,
                },
                {
                  comment: 'for going above and beyond',
                  count: 0,
                },
                {
                  comment: 'for being awesome at an ace',
                  count: 0,
                },
              ],
            },
            levels: {
              __typename: 'UnifiedGamificationLevel',
              id: 'ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level',
              currentLevelArt:
                'https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120',
              currentLevelDescription: 'Level 1',
              currentLevelName: 'Seed',
              currentPoints: 23,
              maxPoints: 150,
              nextLevelName: 'Root',
            },
          },
        },
      },
    },
  }),
  CoursesQuery: (variables: Variables) => ({
    data: {
      lpLearnerData: {
        learnerByAtlassianId: {
          courses: {
            __typename: 'LpCourseProgressConnection',
            totalCount: 7,
          },
          id: 'ari:cloud:learning-platform::learner/3a2b9c71-18a2-4b07-8fcb-fbc16cdafeb1',
        },
      },
    },
  }),
  StatsSnapshotQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          forums: {
            __typename: 'UnifiedForums',
            id: 'ari:cloud:unified-portable-profile::forums/723',
            snapshot: {
              __typename: 'UnifiedForumsSnapshot',
              id: 'ari:cloud:unified-portable-profile::forums/723/snapshot',
              acceptedAnswersCreated: 12,
              answersCreated: 11,
              articlesCreated: 93,
              kudosReceived: 1,
              totalPosts: 1,
              rank: 'RISING STAR',
            },
          },
        },
      },
    },
  }),
  UnifiedForumsGroupsQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          forums: {
            __typename: 'UnifiedForums',
            id: 'ari:cloud:unified-portable-profile::forums/723',
            groups: {
              __typename: 'UnifiedForumsGroupsConnection',
              edges: [
                {
                  cursor: '0',
                  node: {
                    viewHref: '/t5/Welcome-Center/gh-p/WelcomeCenter',
                    title: 'Welcome Center',
                    groupMemberCount: 11,
                    aaid: '62587f99fdb60b0069294184',
                    topicsCount: 6,
                    hasHiddenAncestor: false,
                    joinDate: '2022-06-23T16:50:44Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref: '',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter',
                  },
                },
                {
                  cursor: '1',
                  node: {
                    viewHref: '/t5/Toronto-AUG/gh-p/TorontoAUG',
                    title: 'Toronto AUG',
                    groupMemberCount: 2,
                    aaid: '62587f99fdb60b0069294184',
                    topicsCount: 1,
                    hasHiddenAncestor: false,
                    joinDate: '2022-06-23T17:03:20Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref: '',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:TorontoAUG',
                  },
                },
                {
                  cursor: '2',
                  node: {
                    viewHref: '/t5/San-Diego-AUG/gh-p/SanDiegoAUG',
                    title: 'San Diego AUG',
                    groupMemberCount: 6,
                    aaid: '62587f99fdb60b0069294184',
                    topicsCount: 6,
                    hasHiddenAncestor: false,
                    joinDate: '2022-06-23T17:02:31Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref: '',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SanDiegoAUG',
                  },
                },
                {
                  cursor: '3',
                  node: {
                    viewHref: '/t5/Secret-AUG/gh-p/SecretAUG',
                    title: 'Secret AUG',
                    groupMemberCount: 4,
                    aaid: '62587f99fdb60b0069294184',
                    topicsCount: 0,
                    hasHiddenAncestor: false,
                    joinDate: '2022-06-23T17:02:15Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref: '',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SecretAUG',
                  },
                },
                {
                  cursor: '4',
                  node: {
                    viewHref: '/t5/Austin-AUG/gh-p/aug-atx',
                    title: 'Austin AUG',
                    groupMemberCount: 16,
                    aaid: '62587f99fdb60b0069294184',
                    topicsCount: 32,
                    hasHiddenAncestor: false,
                    joinDate: '2022-09-28T15:44:23Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref:
                        '/t5/image/serverpage/image-id/292i59680227343233C1/image-size/medium?v=v2&px=400',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:aug-atx',
                  },
                },
                {
                  cursor: '5',
                  node: {
                    viewHref: '/t5/Rooting-for-Raisins/gh-p/RootingforRaisins',
                    title: 'Rooting for Raisins',
                    groupMemberCount: 4,
                    aaid: '62587f99fdb60b0069294184',
                    topicsCount: 4,
                    hasHiddenAncestor: false,
                    joinDate: '2024-01-23T21:43:48Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref:
                        '/t5/image/serverpage/image-id/263iDC6C8847513F900E/image-size/medium?v=v2&px=400',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:RootingforRaisins',
                  },
                },
              ],
              totalCount: 6,
            },
          },
        },
      },
    },
  }),
  ProfileBadgesQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          aaid: '62587f99fdb60b0069294184',
          learning: {
            __typename: 'UnifiedLearning',
            id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184',
            recentCoursesBadges: {
              __typename: 'UnifiedProfileBadgesConnection',
              edges: [
                {
                  cursor: '0',
                  node: {
                    actionUrl: 'https://www.atlassian.com',
                    imageUrl: 'https://randomuser.me/api/portraits/men/6.jpg',
                    name: 'Test Course Four',
                    id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1',
                  },
                },
                {
                  cursor: '1',
                  node: {
                    imageUrl: 'https://randomuser.me/api/portraits/men/4.jpg',
                    name: 'Test Course Two',
                    id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/2',
                  },
                },
                {
                  cursor: '2',
                  node: {
                    name: 'Test Course Three',
                    id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/3',
                    imageUrl: 'https://randomuser.me/api/portraits/women/1.jpg',
                  },
                },
                {
                  cursor: '3',
                  node: {
                    name: 'Test Course One',
                    id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/4',
                    imageUrl: 'https://randomuser.me/api/portraits/women/2.jpg',
                  },
                },
                {
                  cursor: '4',
                  node: {
                    name: 'Test Course Five',
                    id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/5',
                    imageUrl: 'https://randomuser.me/api/portraits/women/3.jpg',
                  },
                },
              ],
              totalCount: 5,
            },
          },
          badges: {
            __typename: 'UnifiedProfileBadgesConnection',
            edges: [
              {
                node: {
                  description: 'Answer 1 question tagged “cloud”',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589',
                  imageUrl:
                    'https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530',
                  name: 'Cloudie',
                  type: 'kms',
                },
              },
              {
                node: {
                  description: 'Answers accepted',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-7',
                  imageUrl: '',
                  name: 'First Accepted Solution',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: null,
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-37',
                  imageUrl: '',
                  name: 'Level 0',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Likes received',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-15',
                  imageUrl: '',
                  name: 'First Like Received',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: null,
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-31',
                  imageUrl: '',
                  name: 'Test Peter',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Topics discussed',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-12',
                  imageUrl: '',
                  name: '5 Topics Discussed',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Topics discussed',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-11',
                  imageUrl: '',
                  name: 'First Topic Discussed',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Role badges',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-20',
                  imageUrl: '',
                  name: 'Atlassian Team',
                  type: 'khoros',
                },
              },
            ],
            pageInfo: {
              endCursor: '8',
              hasNextPage: false,
              hasPreviousPage: false,
              startCursor: '0',
            },
            totalCount: 8,
          },
        },
      },
    },
  }),
  UnifiedLearningCertificationQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          aaid: '62587f99fdb60b0069294184',
          learning: {
            __typename: 'UnifiedLearning',
            certifications: {
              __typename: 'UnifiedLearningCertificationConnection',
              id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/certifications',
              edges: getMockedCertmetricsCertificatesEdges({
                count: variables.first ?? 10,
                withEmeritus: true,
              }),
              totalCount: 10,
            },
          },
        },
      },
    },
  }),
  ProfileHeaderQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          company: 'Nike',
          aaid: '62587f99fdb60b0069294184',
          location: 'Kansas, USA',
          role: 'CEO',
          username: 'fullloggedout',
        },
      },
    },
  }),
};
